const ToggleSwitch = ({
	label,
	isChecked,
	onToggle,
}: {
	label: string;
	isChecked: boolean;
	onToggle: () => void;
}) => {
	return (
		<label className="flex items-center justify-between">
			<span className="text-lg font-semibold">{label}</span>
			<div
				className={`w-12 h-6 flex items-center bg-gray-600 rounded-full p-1 cursor-pointer ${isChecked ? 'bg-blue-900' : ''
					}`}
				onClick={onToggle}
			>
				<div
					className={`w-4 h-4 bg-gray-50 rounded-full shadow-md transform duration-300 ${isChecked ? 'translate-x-6' : ''
						}`}
				></div>
			</div>
		</label>
	);
};

export default ToggleSwitch;
